import { toArray, get, keyBy, forEach } from 'lodash';

function validateOxygenChecks(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const checkNodes = nodes.filter((node) => node.name === 'Check');
  const oxygens = (caseConf._oxygens || []).filter(o => get(o, 'options.enabled'));
  const oxygensById = keyBy(oxygens, 'id');
  const errors = [];
  const warnings = [];
  checkNodes.forEach((checkNode) => {
    forEach(checkNode.data, (check, checkKey) => {
      if (check.id !== 'OXYGEN') return;

      if (!oxygens.length) {
        warnings.push({
          message: 'Oxygen is not enabled',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: checkNode.id,
          metadata: {
            nodeId: checkNode.id,
            scope: 'control',
          },
        });
      }

      (check.oxygens || []).forEach((oxygenRoute) => {
        const oxygen = oxygensById[oxygenRoute];

        if (!oxygen || !oxygen.options.enabled) {
          const label = get(oxygen, 'name.en', oxygenRoute);
          warnings.push({
            message: `${label} is used in case logic but is not enabled`,
            category: 'oxygen',
            field: '_oxygens',
            id: oxygenRoute,
            metadata: {
              nodeId: checkNode.id,
              oxygenKey: check.id,
              scope: 'control',
            },
          });
          warnings.push({
            message: `${label} is not enabled`,
            category: 'caseLogic',
            field: 'caseLogicDescription',
            id: checkNode.id,
            metadata: {
              nodeId: checkNode.id,
              checkKey,
              scope: 'control',
            },
          });
        }
      });
    });
  });
  return {
    errors,
    warnings,
  };
}

export default validateOxygenChecks;
